import styled from 'styled-components';
import { fonts } from 'styles';

export const Container = styled.main`
  width: 100%;
  max-width: 1920px;
  margin: 0 auto;
  overflow-x: hidden;
`;

export const Content = styled.section`
  width: 100%;
  max-width: 736px;
  margin: 0 auto;
  padding: 164px 24px;

  @media screen and (max-width: 500px) {
    padding: 64px 24px;
  }
`;

export const Text = styled.article`
  font-family: ${fonts.BentonSansRegular};
  font-size: 16px;
  line-height: 26px;

  .drop-caps:first-letter {
    font-size: 4em;
    float: left;
    padding: 0 10px 0 0;
    font-family: ${fonts.BentonSansWideBlack};
    line-height: 1em;
  }

  p {
    margin-bottom: 16px;
    &:last-child {
      margin-bottom: 0;
    }
  }
`;
